import React, { useRef, useState } from "react";
import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, y = 30, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Magnetic({ children, className = "" }) {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    setPos({ x: (e.clientX - r.left - r.width / 2) * 0.22, y: (e.clientY - r.top - r.height / 2) * 0.22 });
  };
  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={() => setPos({ x: 0, y: 0 })}
      animate={{ x: pos.x, y: pos.y }}
      transition={{ type: "spring", stiffness: 180, damping: 14 }}
      className={`inline-block ${className}`}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, sub, align = "left" }) {
  return (
    <Reveal className={align === "center" ? "text-center" : ""}>
      <p className="eyebrow" data-testid="section-eyebrow">{eyebrow}</p>
      <h2 className="mt-3 font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight" style={{ color: "var(--mn-text)" }}>
        {title}
      </h2>
      {sub && (
        <p className="mt-3 max-w-xl text-sm sm:text-base leading-relaxed" style={{ color: "var(--mn-text2)", marginInline: align === "center" ? "auto" : undefined }}>
          {sub}
        </p>
      )}
    </Reveal>
  );
}
